<template>
  <div class="add-address">
    <!-- 引入公共头部 :showBack="true" :showEdit="true"-->
    <dg-header :showBack="true" title="编辑地址"></dg-header>
    <!-- 地址编辑 -->
    <van-address-edit
      :area-list="areaList"
      show-delete
      :address-info="addressInfo"
      @save="onSave"
      @delete="onDelete"
      @change-detail="onChangeDetail"
    />
  </div>
</template>

<script>
import DgHeader from "@/components/header";

export default {
  data() {
    return {
      // 地址
      areaList: {
        province_list: {
          110000: "北京市",
          120000: "天津市"
        },
        city_list: {
          110100: "北京市",
          110200: "县",
          120100: "天津市",
          120200: "县"
        },
        county_list: {
          110101: "东城区",
          110102: "西城区",
          110105: "朝阳区",
          110106: "丰台区",
          120101: "和平区",
          120102: "河东区",
          120103: "河西区",
          120104: "南开区",
          120105: "河北区"
        }
      },
      addressInfo: [
        {
          id: '001',
          name: '章三',
          tel: '12345678912',
          
        }
      ]
    };
  },
  components: {
    DgHeader
  },
  methods: {
    onSave() {
      this.Toast("save");
    },
    onDelete() {
      this.Toast("delete");
    },
    onChangeDetail(val) {
      if (val) {
        this.searchResult = [
          {
            name: "黄龙万科中心",
            address: "杭州市西湖区"
          }
        ];
      } else {
        this.searchResult = [];
      }
    }
  }
};
</script>
<style lang="scss" >
.add-address {
  .van-cell {
    margin-bottom: 8px;
    .van-cell__title {
      > span {
        font-size: 28px;
        color: $fc09;
      }
    }
    .van-field__control {
      color: $fc03;
      font-size: 28px;
    }
  }
  // 保存删除按钮
  .van-address-edit__buttons {
    > button {
      border-radius: $br50;
      font-size: 30px;
      &:first-child {
        background: $bg05;
        border: none;
      }
      &:last-child {
        background: none;
        border: 2px solid $bc03;
        color: $fc10;
      }
    }
  }

  .van-cell:not(:last-child)::after {
    border-bottom: none;
  }
}
</style>

